import { createFileRoute } from '@tanstack/react-router';

import { useTranslation } from '@apple/lib/i18next';
import { DataTable } from '@apple/ui/data-table/controls/data-table';
import { TableLayout } from '@apple/ui/layouts/TableLayout';

import { requireAuth } from '@apple/features/auth/utils/require-auth';
import { useLocationFeedTable } from '@apple/features/report/location-feed/hooks/useLocationFeedTable';

export const Route = createFileRoute('/_authed/_admin/reports/location-feed')({
	beforeLoad: args =>
		requireAuth(args, {
			requirePermission:
				'AppleBrandedPrograms.Security.Features.AppleIdFeedLocationsManagement.Read',
		}),
	component: LocationFeedRoute,
});

function LocationFeedRoute() {
	const { t } = useTranslation('reports');
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	const { table, locationFeedQuery } = useLocationFeedTable({ search, navigate });
	return (
		<TableLayout title={t('locationFeed.title')} table={table}>
			<DataTable table={table} minWidth='3000px' loading={locationFeedQuery.isFetching} />
		</TableLayout>
	);
}
